module.exports = __webpack_public_path__ + "img/goods-2.d875b28f.png";